import { IHousingObjectResponse } from '@/types';
import { StructuredData } from '@/types/structuredData';
import { buildListingListItems } from './buildListingListItems';

export const generateBrokerListingsSchema = (
  objects: IHousingObjectResponse[],
  officeName: string,
  locale: string,
  section: 'housing' | 'project' = 'housing',
): StructuredData => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: `Weitere Objekte von ${officeName}`,
  numberOfItems: objects.length,
  itemListElement: buildListingListItems(objects, locale, section),
});
